import { Component, inject } from '@angular/core';
import { TranslatePipe } from '../../../core/i18n/translate.pipe';
import { HttpLoadingService } from '../../../core/services/http-loading.service';

@Component({
  selector: 'app-global-loading',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    @if (loading.visible()) {
      <div class="global-loading-backdrop" role="status" aria-live="polite" aria-busy="true">
        <div class="global-loading-panel">
          <span class="global-loading-spinner" aria-hidden="true"></span>
          <span class="global-loading-text">{{ 'common.loading' | t }}</span>
        </div>
      </div>
    }
  `,
  styles: [
    `
      .global-loading-backdrop {
        position: fixed;
        inset: 0;
        z-index: 12000;
        display: grid;
        place-items: center;
        background: rgba(15, 23, 42, 0.18);
        backdrop-filter: blur(1px);
        pointer-events: all;
      }

      .global-loading-panel {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.75rem;
        min-width: 9rem;
        padding: 1.25rem 1.5rem;
        border-radius: 0.75rem;
        background: var(--surface-container-lowest, #fff);
        box-shadow: 0 12px 40px rgba(15, 23, 42, 0.18);
        color: var(--on-surface, #1f2937);
      }

      .global-loading-spinner {
        width: 2rem;
        height: 2rem;
        border: 3px solid rgba(15, 23, 42, 0.12);
        border-top-color: var(--primary, #2563eb);
        border-radius: 999px;
        animation: global-loading-spin 0.8s linear infinite;
      }

      .global-loading-text {
        font-size: 0.875rem;
        font-weight: 500;
      }

      @keyframes global-loading-spin {
        to {
          transform: rotate(360deg);
        }
      }
    `
  ]
})
export class GlobalLoadingComponent {
  readonly loading = inject(HttpLoadingService);
}
